export default __webpack_public_path__ + "static/media/client02.3c671394.jpg";